import React from 'react';
import { Row, Col, Menu, Button } from 'antd';
import { Inference } from '../../../types';
import { CustomSider } from '../../../components/layout/CustomSider';
import { Section } from '../../../components/Section';
import { SectionTitle } from '../../../components/text/Titles';

type Props = {
  readOnly?: boolean;
  inferenceList: null | Inference[];
  selectedId: null | string;
  onInferenceClick: (inferenceId: string) => any;
  onTrain: () => any;
};

const ReviewMenuSideBar = (props: Props) => {
  const { readOnly, inferenceList, selectedId, onInferenceClick, onTrain } = props;

  return (
    <CustomSider width={300} border="right" style={{ paddingTop: '1.25rem' }}>
      <Section>
        <SectionTitle fontSize={20}>
          {/* <span style={{ fontSize: 20, fontWeight: 700, color: '#005ea0' }}> */}
          {readOnly ? 'Reviewed documents' : 'Review the documents'}
        </SectionTitle>
      </Section>

      {!readOnly && (
        <Section>
          <span>Check each document on errors before you start training the model.</span>
        </Section>
      )}

      <Row>
        <Col span={24}>
          <Menu mode="inline" selectedKeys={[selectedId || '']}>
            {inferenceList &&
              inferenceList.map(inference => {
                return (
                  <Menu.Item key={`${inference.id}`} onClick={() => onInferenceClick(inference.id)}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ color: '#494a50', fontSize: 14 }}>{inference.fileName}</span>
                    </div>
                  </Menu.Item>
                );
              })}
          </Menu>
        </Col>
        {!readOnly && (
          <Section>
            <Button type="primary" className="w-full h-10 bg-toolbox-primary border-toolbox-primary" onClick={onTrain}>
              Train Model
            </Button>
          </Section>
        )}
      </Row>
    </CustomSider>
  );
};

export default ReviewMenuSideBar;
